import styled from 'styled-components'

export default styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px;

  header {
    display: flex;
    justify-content: center !important;

    h3 {
      font-size: 22px !important;
    }
  }

  .options-container {
    margin: 20px 0 24px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: stretch;

    .option {
      height: 50px;
      margin-top: 15px;
      border: 1px solid ${ ({ theme }) => theme.colors.blue };
      border-radius: 25px;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      cursor: pointer;

      span {
        font-size: 16px;
        color: ${ ({ theme }) => theme.colors.blue };
      }
    }

    .option:hover {
      background-color: ${ ({ theme }) => theme.colors.blue }30;
    }
  }

  .buttons-container {
    display: flex;
    flex-direction: row;
    margin: 24px 0;
    justify-content: space-around;

    .feedback-button {
      width: 90px;
      height: 90px;
      border-radius: 45px;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      cursor: pointer;

      img {
        width: 46px;
        height: 43px;
      }

      &.positive {
        background-color: ${ ({ theme }) => theme.colors.mediumGreen };
      }

      &.negative {
        background-color: ${ ({ theme }) => theme.colors.mediumRed };
      }
    }
  }

  footer {
    margin: 0 !important;
    justify-content: center !important;
    .skip {
      font-size: 16px;
      color: ${ ({ theme }) => theme.colors.blue };
      text-decoration-line: underline;
      text-align: center;
      cursor: pointer;
    }
  }
`